module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "no-select",
    staticStyle: {
      "margin": "24px"
    }
  }, [_vm._v(_vm._s(_vm.deck.name))]), _vm._v(" "), (_vm.cards.length > 0) ? _c('section', {
    staticClass: "cardlist"
  }, [_c('transition-group', {
    attrs: {
      "name": "card"
    }
  }, _vm._l((_vm.cards), function(card) {
    return _c('router-link', {
      key: card['.key'],
      staticClass: "card",
      class: {
        selected: _vm.selectedCards[card['.key']]
      },
      style: ({
        backgroundColor: card.color
      }),
      attrs: {
        "to": {
          name: 'card',
          params: {
            deckId: _vm.deckId,
            cardId: card['.key']
          }
        }
      }
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.selectedCards[card['.key']]) ? _c('a', {
      staticStyle: {
        "color": "#040",
        "font-size": "0.8rem"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectCard(card['.key'])
        }
      }
    }, [_vm._v("select")]) : _vm._e(), _vm._v(" "), (_vm.selectedCards[card['.key']]) ? _c('a', {
      staticStyle: {
        "color": "#a33",
        "font-size": "0.8rem"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deselectCard(card['.key'])
        }
      }
    }, [_vm._v("deselect")]) : _vm._e()])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cards.length === 0) ? _c('div', {
    staticClass: "no-cards no-select"
  }, [_vm._v("\n    You have no cards in this deck so far. Click "), _vm._m(0), _vm._v(" to add the first one.\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('strong', [_vm._v("ADD CARD")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6293d840","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deck.vue
// module id = 289
// module chunks = 1